import {all, takeLatest, takeEvery, fork} from 'redux-saga/effects';
import { LOGIN_REQUEST } from "./actions/authActions";
import { loginSaga } from "./sagas/authSaga";

import {
    ADMIN_NOTE_FRAIS_DECISION_REQUEST,
    CREATE_NOTE_FRAIS_REQUEST_REQUEST, GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST,
    GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST, GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST,
    GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST,
    GET_MY_NOTE_FRAIS_REQUESTS_REQUEST, GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST,
    GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST,
    MANAGER_NOTE_FRAIS_DECISION_REQUEST,
    MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST
} from "./actions/noteDeFraisRequestActions";

import {
    approveDemandeRecrutementSaga, cancelDemandeRecrutementSaga,
    createDemandeRecrutementSaga, deleteDemandeRecrutementSaga,
    fetchDemandesRecrutementSaga, rejectDemandeRecrutementSaga, sendOfferToChasseursSaga, sendOfferToPartenairesSaga,
    updateDemandeRecrutementSaga
} from "./sagas/demandesRecrutementSagas";
import {
    APPROVE_DEMANDE_RECRUTEMENT_REQUEST, CANCEL_DEMANDE_RECRUTEMENT_REQUEST,
    CREATE_DEMANDE_RECRUTEMENT_REQUEST,
    DELETE_DEMANDE_RECRUTEMENT_REQUEST, FETCH_DEMANDES_RECRUTEMENT_REQUEST,

    REJECT_DEMANDE_RECRUTEMENT_REQUEST, SEND_OFFER_TO_CHASSEURS_REQUEST, SEND_OFFER_TO_PARTENAIRES_REQUEST,
    UPDATE_DEMANDE_RECRUTEMENT_REQUEST
} from "./actions/demandesRecrutementActions";

import {
    CREATE_TIMESHEET_REQUEST, DELETE_TIMESHEET_DAY_REQUEST, DELETE_TIMESHEET_REQUEST, FETCH_TIMESHEET_DAYS_REQUEST,
    FETCH_TIMESHEETS_REQUEST,
    GET_TIMESHEET_REQUEST,
    UPDATE_TIMESHEET_REQUEST, UPSERT_TIMESHEET_DAY_REQUEST
} from "./actions/timesheetActions";
import {
    createTimesheetSaga, deleteTimesheetDaySaga,
    deleteTimesheetSaga, fetchTimesheetDaysSaga, fetchTimesheetsSaga,
    getTimesheetSaga,
    updateTimesheetSaga, upsertTimesheetDaySaga
} from "./sagas/timesheetSaga";
import {
    adminNoteDeFraisDecisionSaga,
    createNoteDeFraisRequestSaga, getAdminNoteDeFraisHistorySaga,
    getAdminNoteDeFraisInboxSaga, getManagerNoteDeFraisHistorySaga,
    getManagerNoteDeFraisInboxSaga,
    getMyNoteDeFraisRequestsSaga, getNoteDeFraisByOrdreMissionSaga,
    getNoteDeFraisEnAttenteRemboursementSaga,
    managerNoteDeFraisDecisionSaga,
    marquerNoteDeFraisRembourseeSaga
} from "./sagas/noteDeFraisRequestSaga";
import {
    ADMIN_AVANCE_DECISION_REQUEST,
    CREATE_AVANCE_REQUEST_REQUEST,
    ENREGISTRER_REMBOURSEMENT_REQUEST, GET_ADMIN_AVANCE_HISTORY_REQUEST,
    GET_ADMIN_AVANCE_INBOX_REQUEST,
    GET_MANAGER_AVANCE_INBOX_REQUEST,
    GET_MY_AVANCE_REQUESTS_REQUEST,
    GET_MY_AVANCES_EN_COURS_REQUEST,
    MANAGER_AVANCE_DECISION_REQUEST, REMBOURSEMENT_ANTICIPE_REQUEST,
    GET_MANAGER_AVANCE_HISTORY_REQUEST,
    EXPORT_AVANCE_REQUESTS_EXCEL_REQUEST
} from "./actions/avanceRequestActions";
import {
    adminAvanceDecisionSaga,
    createAvanceRequestSaga, enregistrerRemboursementSaga, getAdminAvanceHistorySaga, getAdminAvanceInboxSaga,
    getManagerAvanceInboxSaga,
    getMyAvanceRequestsSaga,
    getMyAvancesEnCoursSaga, managerAvanceDecisionSaga, remboursementAnticipeSaga, getManagerAvanceHistorySaga,
    exportAvanceRequestsExcelSaga
} from "./sagas/avanceRequestsSaga";
import {
    ADMIN_MISSION_DECISION_REQUEST,
    CANCEL_MISSION_REQUEST_REQUEST, CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST,
    CREATE_MISSION_REQUEST_REQUEST, GET_ADMIN_MISSION_HISTORY_REQUEST,
    GET_ADMIN_MISSION_INBOX_REQUEST, GET_ALL_MISSION_REQUESTS_REQUEST,
    GET_MANAGER_MISSION_HISTORY_REQUEST,
    GET_MANAGER_MISSION_INBOX_REQUEST,
    GET_MISSION_REQUEST_REQUEST,
    GET_MY_MISSION_REQUESTS_REQUEST,
    MANAGER_MISSION_DECISION_REQUEST
} from "./actions/missionRequestActions";
import {
    adminMissionDecisionSaga,
    cancelMissionRequestSaga, createMissionRequestForCollabSaga,
    createMissionRequestSaga,
    getAdminMissionHistorySaga,
    getAdminMissionInboxSaga, getAllMissionRequestsSaga,
    getManagerMissionHistorySaga,
    getManagerMissionInboxSaga,
    getMissionRequestSaga,
    getMyMissionRequestsSaga,
    managerMissionDecisionSaga
} from "./sagas/missionRequestSaga";




import {
    GET_USER_REQUEST,
    GET_ALL_USERS_REQUEST,
    GET_USERS_BY_STATUS_REQUEST,
    GET_USERS_BY_JOB_REQUEST,
    GET_USERS_BY_ENTITY_REQUEST,
    CREATE_USER_REQUEST,
    UPDATE_USER_REQUEST,
    DELETE_USER_REQUEST,
    ASSIGN_ROLES_REQUEST,
    REMOVE_ROLES_REQUEST, MASS_IMPORT_USERS_REQUEST, DOWNLOAD_USERS_TEMPLATE_REQUEST, REVIEW_USERS_MASS_IMPORT_REQUEST,
    IMPORT_USERS_MASS_REQUEST, GET_TROMBINOSCOPE_REQUEST, GET_USER_JOB_HISTORY_REQUEST, GET_DIRECT_REPORTS_REQUEST,
    UPDATE_MY_PROFILE_REQUEST, UPLOAD_USER_PHOTO_REQUEST, EXPORT_USERS_REQUEST
} from "./actions/userActions";


import {
    CREATE_DOMAINE_REQUEST, CREATE_THEME_REQUEST, DELETE_DOMAINE_REQUEST, DELETE_THEME_REQUEST,
    DOWNLOAD_DOMAINES_TEMPLATE_REQUEST, DOWNLOAD_THEMES_TEMPLATE_REQUEST,
    FETCH_DOMAINES_REQUEST,
    FETCH_THEMES_BY_DOMAINE_REQUEST,
    FETCH_THEMES_REQUEST, IMPORT_DOMAINES_EXCEL_REQUEST,
    IMPORT_THEMES_EXCEL_REQUEST, UPDATE_DOMAINE_REQUEST, UPDATE_THEME_REQUEST,
} from "./actions/paramDomainesThemesActions";



import {
    getUserSaga,
    getAllUsersSaga,
    getUsersByStatusSaga,
    getUsersByJobSaga,
    getUsersByEntitySaga,
    createUserSaga,
    updateUserSaga,
    deleteUserSaga,
    assignRolesSaga,
    removeRolesSaga, massImportUsersSaga, downloadUsersTemplateSaga, importUsersMassSaga, reviewUsersMassImportSaga,
    getTrombinoscopeSaga, getUserJobHistorySaga, getDirectReportsSaga, uploadUserPhotoSaga, updateMyProfileSaga,
    exportUsersSaga
} from "./sagas/userSagas";
import {
    CREATE_JOB_REQUEST,
    DELETE_JOB_REQUEST, DOWNLOAD_JOBS_TEMPLATE_REQUEST, EXPORT_JOBS_REQUEST,
    GET_ALL_JOBS_REQUEST,
    IMPORT_JOBS_EXCEL_REQUEST,
    UPDATE_JOB_REQUEST
} from "./actions/Jobactions";
import {
    createJobSaga,
    deleteJobSaga, downloadJobsTemplateSaga,
    exportJobsExcelSaga,
    getAllJobsSaga,
    importJobsExcelSaga,
    updateJobSaga
} from "./sagas/jobSaga";
import {
    CREATE_ENTITE_REQUEST,
    DELETE_ENTITE_REQUEST, DOWNLOAD_ENTITIES_TEMPLATE_REQUEST, EXPORT_ENTITIES_REQUEST,
    GET_ALL_ENTITES_REQUEST, GET_ORGANIGRAMME_REQUEST, IMPORT_ENTITIES_EXCEL_REQUEST,
    UPDATE_ENTITE_REQUEST
} from "./actions/entitesActions";
import {
    createEntiteSaga,
    deleteEntiteSaga, downloadEntitiesTemplateSaga, exportEntitiesExcelSaga,
    getAllEntitesSaga,
    getOrgSaga,
    importEntitiesExcelSaga,
    updateEntiteSaga
} from "./sagas/entitesSaga";
import {
    CREATE_AV_CAT_REQUEST,
    CREATE_AV_REGLE_REQUEST,
    CREATE_AVANTAGE_REQUEST,
    DELETE_AV_CAT_REQUEST,
    DELETE_AV_REGLE_REQUEST, DELETE_AVANTAGE_REQUEST,
    FETCH_PARAM_AVANTAGES_REQUEST,
    UPDATE_AV_CAT_REQUEST,
    UPDATE_AV_REGLE_REQUEST, UPDATE_AVANTAGE_REQUEST
} from "./actions/paramAvantagesActions";
import {
    createAvantageSaga,
    createAvCatSaga,
    createAvRegleSaga, deleteAvantageSaga,
    deleteAvCatSaga, deleteAvRegleSaga,
    fetchParamAvantagesSaga, updateAvantageSaga,
    updateAvCatSaga, updateAvRegleSaga
} from "./sagas/paramAvantagesSaga";



import {
    GET_SIDEBAR_MENU_REQUEST,
    GET_ALL_SIDEBAR_MENUS_REQUEST,
    GET_ORDERED_SIDEBAR_MENUS_REQUEST,
    GET_SIDEBAR_MENUS_BY_ROLE_REQUEST,
    GET_SIDEBAR_MENUS_BY_STATUS_REQUEST,
    GET_ROOT_SIDEBAR_MENUS_REQUEST,
    GET_CHILD_SIDEBAR_MENUS_REQUEST,
    CREATE_SIDEBAR_MENU_REQUEST,
    UPDATE_SIDEBAR_MENU_REQUEST,
    DELETE_SIDEBAR_MENU_REQUEST, GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST
} from './actions/sidebarMenuActions';

import {
    getSidebarMenuSaga,
    getAllSidebarMenusSaga,
    getOrderedSidebarMenusSaga,
    getSidebarMenusByRoleSaga,
    getSidebarMenusByStatusSaga,
    getRootSidebarMenusSaga,
    getChildSidebarMenusSaga,
    createSidebarMenuSaga,
    updateSidebarMenuSaga,
    deleteSidebarMenuSaga, getSidebarMenusByRoleAdminSaga
} from './sagas/sidebarMenuSagas';

import {
    GET_COMPANY_REQUEST,
    GET_COMPANY_BY_CODE_REQUEST,
    GET_ALL_COMPANIES_REQUEST,
    CREATE_COMPANY_REQUEST,
    UPDATE_COMPANY_REQUEST,
    DELETE_COMPANY_REQUEST, GET_HOLIDAYS_REQUEST
} from "./actions/companyactions";

import {
    getCompanySaga,
    getCompanyByCodeSaga,
    getAllCompaniesSaga,
    createCompanySaga,
    updateCompanySaga,
    deleteCompanySaga, getHolidaysSaga
} from "./sagas/companySaga";

import {
    GET_ROLE_REQUEST,
    GET_ALL_ROLES_REQUEST,
    GET_ACTIVE_ROLES_REQUEST,
    GET_ROLES_BY_MODULE_REQUEST,
    GET_GLOBAL_ROLES_REQUEST,
    CREATE_ROLE_REQUEST,
    UPDATE_ROLE_REQUEST,
    DELETE_ROLE_REQUEST
} from "./actions/roleActions";

import {
    getRoleSaga,
    getAllRolesSaga,
    getActiveRolesSaga,
    getRolesByModuleSaga,
    getGlobalRolesSaga,
    createRoleSaga,
    updateRoleSaga,
    deleteRoleSaga
} from "./sagas/roleSagas";
import {
    GET_WORKFLOW_LEVELS_REQUEST, SAVE_WORKFLOW_LEVELS_REQUEST,
} from "./actions/workflowValidationActions";
import { getWorkflowLevelsSaga, saveWorkflowLevelsSaga} from "./sagas/workflowValidationSaga";
import {
    CREATE_ABSENCE_TYPE_REQUEST, CREATE_ACQ_RULE_REQUEST,
    CREATE_JUSTIF_RULE_REQUEST, DELETE_ABSENCE_TYPE_REQUEST, DELETE_ACQ_RULE_REQUEST, DELETE_JUSTIF_RULE_REQUEST,
    FETCH_PARAM_CONGES_REQUEST,
    UPDATE_ABSENCE_TYPE_REQUEST, UPDATE_ACQ_RULE_REQUEST, UPDATE_JUSTIF_RULE_REQUEST,
    INIT_STANDARD_CONFIG_REQUEST
} from "./actions/paramCongesActions";
import {
    createAbsenceTypeSaga, createAcqRuleSaga, createJustifRuleSaga,
    deleteAbsenceTypeSaga, deleteAcqRuleSaga, deleteJustifRuleSaga,
    fetchParamCongesSaga,
    updateAbsenceTypeSaga, updateAcqRuleSaga, updateJustifRuleSaga, initStandardConfigSaga
} from "./sagas/paramCongesSaga";
import {
    ADMIN_DECISION_REQUEST,
    CREATE_LEAVE_REQUEST_REQUEST,

    GET_ADMIN_INBOX_REQUEST, GET_MANAGER_INBOX_REQUEST,
    GET_MANAGER_HISTORY_REQUEST,
    GET_MANAGER_TEAM_LEAVES_REQUEST,
    GET_MY_LEAVE_REQUESTS_REQUEST, MANAGER_DECISION_REQUEST,
    MANAGER_DELEGATE_TO_ADMIN_REQUEST,
    POSTPONE_LEAVE_REQUEST_REQUEST,
    UPLOAD_LEAVE_JUSTIFICATIFS_REQUEST,
    GET_ALL_LEAVE_REQUESTS_REQUEST,
    EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST,
} from "./actions/leaveRequestsActions";
import {
    adminDecisionSaga,
    createLeaveRequestSaga,
    getAdminInboxSaga,
    getManagerInboxSaga,
    getManagerHistorySaga,
    getManagerTeamLeavesSaga,
    getMyLeaveRequestsSaga,
    managerDelegateToAdminSaga,
    managerDecisionSaga,
    postponeLeaveRequestSaga,
    uploadLeaveJustificatifsSaga,
    getAllLeaveRequestsSaga,
    exportLeaveRequestsExcelSaga,
} from "./sagas/leaveRequestsSaga";

import {
    createDomaineSaga, createThemeSaga, deleteDomaineSaga, deleteThemeSaga, downloadDomainesTemplateSaga,
    downloadThemesTemplateSaga,
    fetchDomainesSaga,
    fetchThemesByDomaineSaga,
    fetchThemesSaga, importDomainesExcelSaga, importThemesExcelSaga, updateDomaineSaga, updateThemeSaga
} from "./sagas/paramDomainesThemesSaga";

import {
    CREATE_NOTE_DE_FRAIS_REQUEST, DELETE_NOTE_DE_FRAIS_REQUEST, FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST,
    FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST,
    FETCH_NOTE_DE_FRAIS_REQUEST, UPDATE_NOTE_DE_FRAIS_REQUEST
} from "./actions/noteDeFraisActions";
import {
    createNoteDeFraisSaga, deleteNoteDeFraisSaga, fetchNoteDeFraisActifsSaga,
    fetchNoteDeFraisByIdSaga,
    fetchNoteDeFraisSaga,
    updateNoteDeFraisSaga
} from "./sagas/noteDeFraisSaga";
import {
    CREATE_ORDRE_MISSION_REQUEST, DELETE_ORDRE_MISSION_REQUEST, FETCH_ORDRE_MISSION_ACTIFS_REQUEST,
    FETCH_ORDRE_MISSION_BY_ID_REQUEST, FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST, FETCH_ORDRE_MISSION_EN_COURS_REQUEST,
    FETCH_ORDRE_MISSION_REQUEST, UPDATE_ORDRE_MISSION_REQUEST
} from "./actions/ordreMissionActions";
import {
    createOrdreMissionSaga,
    deleteOrdreMissionSaga,
    fetchOrdreMissionActifsSaga, fetchOrdreMissionByIdSaga,
    fetchOrdreMissionByPeriodSaga,
    fetchOrdreMissionEnCoursSaga,
    fetchOrdreMissionSaga, updateOrdreMissionSaga
} from "./sagas/ordreMissionSaga";
import {
    createFormationSaga,
    deleteFormationSaga, downloadTemplateSaga, exportExcelSaga, fetchFormationsByCatalogueSaga,
    fetchFormationsSaga, importExcelSaga,
    updateFormationSaga
} from "./sagas/formationsSaga";
import {
    CREATE_FORMATION_REQUEST, DELETE_FORMATION_REQUEST, DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST, EXPORT_FORMATIONS_REQUEST,
    FETCH_FORMATIONS_BY_CATALOGUE_REQUEST,
    FETCH_FORMATIONS_REQUEST, IMPORT_FORMATIONS_EXCEL_REQUEST,
    UPDATE_FORMATION_REQUEST
} from "./actions/formationsActions";
import {
    createAvanceSaga,
    deleteAvanceSaga, fetchAvanceActifsSaga,
    fetchAvanceByIdSaga,
    fetchAvanceSaga,
    updateAvanceSaga
} from "./sagas/avanceSaga";
import {
    CREATE_AVANCE_REQUEST, DELETE_AVANCE_REQUEST, FETCH_AVANCE_ACTIFS_REQUEST,
    FETCH_AVANCE_BY_ID_REQUEST,
    FETCH_AVANCE_REQUEST,
    UPDATE_AVANCE_REQUEST
} from "./actions/avanceActions";
import {
    CREATE_CATALOGUE_REQUEST, DELETE_CATALOGUE_REQUEST,
    FETCH_CATALOGUES_REQUEST,
    UPDATE_CATALOGUE_REQUEST
} from "./actions/cataloguesActions";
import {
    createCatalogueSaga,
    deleteCatalogueSaga,
    fetchCataloguesSaga,
    updateCatalogueSaga
} from "./sagas/cataloguesSaga";

import {
    CREATE_ETAPE_REQUEST,
    CREATE_OFFBOARDING_REQUEST, DELETE_ETAPE_REQUEST, DELETE_OFFBOARDING_REQUEST, FETCH_ETAPES_REQUEST,
    FETCH_OFFBOARDINGS_REQUEST,
    GET_OFFBOARDING_REQUEST, UPDATE_ETAPE_REQUEST, UPDATE_OFFBOARDING_REQUEST
} from "./actions/offboardingActions";
import {
    createEtapeSaga,
    createOffboardingSaga, deleteEtapeSaga, deleteOffboardingSaga, fetchEtapesSaga,
    fetchOffboardingsSaga,
    getOffboardingSaga, updateEtapeSaga,
    updateOffboardingSaga
} from "./sagas/offboardingSaga";


import {
    adminAttestationDecisionSaga,
    createAttestationRequestSaga,
    createAttestationSaga,
    deleteAttestationSaga, downloadAttestationPdfSaga, downloadAttestationRequestPdfSaga,
    fetchAttestationsSaga,
    getAdminAttestationInboxSaga,
    getManagerAttestationInboxSaga,
    getMyAttestationRequestsSaga,
    managerAttestationDecisionSaga,
    updateAttestationSaga
} from "./sagas/attestationsSaga";
import {
    ADMIN_ATTESTATION_DECISION_REQUEST,
    CREATE_ATTESTATION_REQUEST, CREATE_ATTESTATION_REQUEST_REQUEST, DELETE_ATTESTATION_REQUEST,
    DOWNLOAD_ATTESTATION_PDF_REQUEST, DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST,
    FETCH_ATTESTATIONS_REQUEST,
    GET_ADMIN_ATTESTATION_INBOX_REQUEST, GET_MANAGER_ATTESTATION_INBOX_REQUEST, GET_MY_ATTESTATION_REQUESTS_REQUEST,
    MANAGER_ATTESTATION_DECISION_REQUEST,
    UPDATE_ATTESTATION_REQUEST
} from "./actions/attestationsActions";

import {
    CREATE_PARTENAIRE_ACAD_REQUEST, DELETE_PARTENAIRE_ACAD_REQUEST,
    FETCH_PARTENAIRES_ACAD_REQUEST,
    UPDATE_PARTENAIRE_ACAD_REQUEST
} from "./actions/partenairesAcademiquesActions";
import {
    createPartenaireAcadSaga, deletePartenaireAcadSaga,
    fetchPartenairesAcadSaga,
    updatePartenaireAcadSaga
} from "./sagas/partenairesAcademiquesSaga";
import {
    CREATE_ETABLISSEMENT_REQUEST, DELETE_ETABLISSEMENT_REQUEST,
    FETCH_ETABLISSEMENTS_REQUEST,
    UPDATE_ETABLISSEMENT_REQUEST
} from "./actions/etablissementsActions";
import {
    createEtablissementSaga,
    deleteEtablissementSaga,
    fetchEtablissementsSaga,
    updateEtablissementSaga
} from "./sagas/etablissementsSagas";
import {
    CREATE_CANDIDAT_REQUEST,
    DELETE_CANDIDAT_REQUEST,
    FETCH_CANDIDATS_REQUEST,
    UPDATE_CANDIDAT_REQUEST
} from "./actions/candidatsActions";
import {createCandidatSaga, deleteCandidatSaga, fetchCandidatsSaga, updateCandidatSaga} from "./sagas/candidatsSaga";
import {
    CANCEL_LEAVE_REQUEST_REQUEST,
    CHECK_BALANCE_REQUEST,
    GET_USER_SOLDES_REQUEST,
    GET_ALL_COMPANY_SOLDES_REQUEST,
    EXPORT_SOLDES_EXCEL_REQUEST,
    IMPORT_SOLDES_EXCEL_REQUEST,
    UPDATE_SOLDE_REQUEST,
    GET_USER_MOVEMENTS_REQUEST,
    GET_ALL_MOVEMENTS_REQUEST,
} from "./actions/leaveBalanceActions";
import {
    cancelLeaveRequestSaga,
    checkBalanceSaga,
    getUserSoldesSaga,
    getAllCompanySoldesSaga,
    exportSoldesExcelSaga,
    importSoldesExcelSaga,
    updateSoldeSaga,
    getUserMovementsSaga,
    getAllMovementsSaga,
} from "./sagas/leaveBalanceSaga";


import {
    GET_ALL_EMAIL_TEMPLATES_REQUEST,
    GET_EMAIL_TEMPLATE_REQUEST,
    CREATE_EMAIL_TEMPLATE_REQUEST,
    UPDATE_EMAIL_TEMPLATE_REQUEST,
    DELETE_EMAIL_TEMPLATE_REQUEST,
    GET_EMAIL_PLACEHOLDERS_REQUEST,
    PREVIEW_EMAIL_TEMPLATE_REQUEST,
    SEND_ACCOUNT_ACTIVATION_REQUEST,
    GET_EMAIL_LOGS_REQUEST, REQUEST_PASSWORD_RESET_REQUEST,
    CONFIRM_PASSWORD_RESET_REQUEST,
} from './actions/emailActions';

import {
    GET_NOTIFICATION_SETTINGS_REQUEST,
    CREATE_NOTIFICATION_SETTING_REQUEST,
    UPDATE_NOTIFICATION_SETTING_REQUEST,
    DELETE_NOTIFICATION_SETTING_REQUEST
} from './actions/notificationSettingsActions';

import {
    getAllEmailTemplatesSaga,
    getEmailTemplateSaga,
    createEmailTemplateSaga,
    updateEmailTemplateSaga,
    deleteEmailTemplateSaga,
    getEmailPlaceholdersSaga,
    previewEmailTemplateSaga,
    sendAccountActivationSaga,
    getEmailLogsSaga,
    requestPasswordResetSaga,
    confirmPasswordResetSaga,

} from './sagas/emailSaga';

import {
    getNotificationSettingsSaga,
    createNotificationSettingSaga,
    updateNotificationSettingSaga,
    deleteNotificationSettingSaga
} from './sagas/notificationSettingsSaga';

import watchNotificationSagas from './sagas/notificationSaga';

import { watchTaskSettings } from './sagas/taskSettingsSaga';
import taskSaga from './sagas/taskSaga';

import {
    CREATE_CAMPAGNE_REQUEST, DELETE_CAMPAGNE_REQUEST, FETCH_BUDGET_BY_CAMPAGNE_REQUEST,
    FETCH_CAMPAGNES_REQUEST,
    FETCH_VISIBLE_CAMPAGNES_REQUEST, UPDATE_CAMPAGNE_REQUEST
} from "./actions/campagnesActions";
import {
    createCampagneSaga, deleteCampagneSaga, fetchBudgetByCampagneSaga,
    fetchCampagnesSaga,
    fetchVisibleCampagnesSaga,
    updateCampagneSaga
} from "./sagas/campagnesSaga";
import {
    GET_CALENDAR_SETTINGS_REQUEST,
    GET_WORKDAYS_CONFIG_REQUEST,
    UPDATE_CALENDAR_SETTINGS_REQUEST,
    UPDATE_WORKDAYS_CONFIG_REQUEST
} from "./actions/workDaysActions";
import {
    getCalendarSettingsSaga,
    getWorkdaysConfigSaga,
    updateCalendarSettingsSaga,
    updateWorkdaysConfigSaga
} from "./sagas/workDaysSaga";
import {
    FETCH_MES_AVANTAGES_REQUEST,
} from "./actions/mesAvantagesActions";
import {

    fetchMesAvantagesSaga,
} from "./sagas/mesAvantagesSaga";
import {
    CREATE_DEMANDE_COLLAB_REQUEST,
    CREATE_DEMANDE_MANAGER_BULK_REQUEST, CREATE_DEMANDE_MANAGER_REQUEST,
    CREATE_DEMANDE_RF_BULK_REQUEST, CREATE_DEMANDE_RF_REQUEST,
    DEMANDE_MANAGER_DECISION_REQUEST, DEMANDE_RF_DECISION_REQUEST,
    DOWNLOAD_BILAN_FORMATION_REQUEST, DOWNLOAD_PLAN_FORMATION_REQUEST, GET_COMPANY_DEMANDES_REQUEST,
    GET_CREATED_BY_ME_DEMANDES_REQUEST, GET_DEMANDE_MANAGER_INBOX_REQUEST, GET_DEMANDE_RF_INBOX_REQUEST,
    GET_MY_DEMANDES_REQUEST
} from "./actions/demandesActions";
import {
    createDemandeCollabSaga, createDemandeManagerBulkSaga,
    createDemandeManagerSaga, createDemandeRfBulkSaga, createDemandeRfSaga, demandeManagerDecisionSaga,
    demandeRfDecisionSaga, downloadGenerateBilanCampagneExcelSaga,
    downloadGeneratePlanFormationExcelSaga, getCompanyDemandesSaga,
    getCreatedByMeDemandesSaga, getDemandeManagerInboxSaga, getDemandeRfInboxSaga,
    getMyDemandesSaga
} from "./sagas/demandesSaga";
import {createSalleSaga, deleteSalleSaga, fetchSallesSaga, updateSalleSaga} from "./sagas/sallesSaga";
import {
    CREATE_SALLE_REQUEST,
    DELETE_SALLE_REQUEST,
    FETCH_SALLES_REQUEST,
    UPDATE_SALLE_REQUEST
} from "./actions/sallesActions";
import {
    CREATE_FOURNISSEUR_REQUEST, DELETE_FOURNISSEUR_REQUEST,
    FETCH_FOURNISSEURS_REQUEST,
    UPDATE_FOURNISSEUR_REQUEST
} from "./actions/fournisseursActions";
import {
    createFournisseurSaga,
    deleteFournisseurSaga,
    fetchFournisseursSaga,
    updateFournisseurSaga
} from "./sagas/fournisseursSaga";
import {
    CREATE_CONSULTANT_REQUEST, DELETE_CONSULTANT_REQUEST,
    FETCH_CONSULTANTS_REQUEST,
    UPDATE_CONSULTANT_REQUEST
} from "./actions/consultantsActions";
import {
    createConsultantSaga,
    deleteConsultantSaga,
    fetchConsultantsSaga,
    updateConsultantSaga
} from "./sagas/consultantsSaga";
import {
    CREATE_MODULE_CLE_REQUEST, DELETE_MODULE_CLE_REQUEST,
    FETCH_MODULES_CLE_REQUEST,
    UPDATE_MODULE_CLE_REQUEST
} from "./actions/modulesCleActions";
import {
    createModuleCleSaga,
    deleteModuleCleSaga,
    fetchModulesCleSaga,
    updateModuleCleSaga
} from "./sagas/modulesCleSaga";
import {
    cancelEventSaga,
    createEventSaga,
    deleteEventSaga,
    downloadEventsTemplateSaga, duplicateEventSaga, exportBudgetSaga, exportEventsExcelSaga, exportFormationsSaga,
    fetchEventsSaga, importEventsExcelSaga,
    replanifyEventSaga,
    updateEventSaga
} from "./sagas/eventsSaga";
import {
    CANCEL_EVENT_REQUEST,
    CREATE_EVENT_REQUEST,
    DELETE_EVENT_REQUEST, DOWNLOAD_EVENTS_TEMPLATE_REQUEST, DUPLICATE_EVENT_REQUEST, EXPORT_BUDGET_REQUEST,
    EXPORT_EVENTS_EXCEL_REQUEST,
    FETCH_EVENTS_REQUEST, IMPORT_EVENTS_EXCEL_REQUEST, REPLANIFY_EVENT_REQUEST,
    UPDATE_EVENT_REQUEST
} from "./actions/eventsActions";
import {
    CREATE_CHASSEUR_REQUEST,
    DELETE_CHASSEUR_REQUEST,
    FETCH_CHASSEURS_REQUEST,
    UPDATE_CHASSEUR_REQUEST
} from "./actions/chasseursActions";
import {createChasseurSaga, deleteChasseurSaga, fetchChasseursSaga, updateChasseurSaga} from "./sagas/chasseursSaga";
import {
    FETCH_ADMIN_INBOX_REQUEST,
    FETCH_MANAGER_INBOX_REQUEST, FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,
    FETCH_TIMESHEET_MANAGER_INBOX_REQUEST, TIMESHEET_ADMIN_DECISION_REQUEST, TIMESHEET_MANAGER_DECISION_REQUEST
} from "./actions/timesheetWorkflowActions";
import {
    fetchAdminInboxSaga,
    fetchManagerInboxSaga,
    timesheetAdminDecisionSaga,
    timesheetManagerDecisionSaga
} from "./sagas/timesheetWorkflowSaga";
import {
    GET_APPLICATION_LOG_REQUEST,
    GET_APPLICATION_LOGS_BY_MODULE_REQUEST, GET_APPLICATION_LOGS_BY_USER_REQUEST,
    GET_APPLICATION_LOGS_REQUEST
} from "./actions/applicationLogActions";
import {
    getApplicationLogSaga,
    getApplicationLogsByModuleSaga, getApplicationLogsByUserSaga,
    getApplicationLogsSaga
} from "./sagas/applicationLogSagas";
import {
    CREATE_SKILL_REQUEST, DELETE_SKILL_REQUEST, DOWNLOAD_SKILLS_TEMPLATE_REQUEST, EXPORT_SKILLS_REQUEST,
    FETCH_SKILLS_BY_TYPE_REQUEST,
    FETCH_SKILLS_REQUEST, IMPORT_SKILLS_EXCEL_REQUEST,
    UPDATE_SKILL_REQUEST
} from "./actions/skillsActions";
import {
    createSkillSaga,
    deleteSkillSaga, downloadSkillsTemplateSaga, exportSkillsSaga,
    fetchSkillsByTypeSaga,
    fetchSkillsSaga, importSkillsExcelSaga,
    updateSkillSaga
} from "./sagas/skillsSaga";
import {
    createNiveauSkillSaga,
    deleteNiveauSkillSaga,
    fetchNiveauSkillsSaga,
    updateNiveauSkillSaga
} from "./sagas/niveauSkillSaga";
import {
    CREATE_NIVEAU_SKILL_REQUEST,
    DELETE_NIVEAU_SKILL_REQUEST, FETCH_NIVEAU_SKILLS_REQUEST,
    UPDATE_NIVEAU_SKILL_REQUEST
} from "./actions/niveauSkillActions";
import {
    CREATE_JOB_SKILL_REQUEST,
    DELETE_JOB_SKILL_REQUEST,
    FETCH_JOB_SKILLS_REQUEST,
    UPDATE_JOB_SKILL_REQUEST
} from "./actions/jobSkillActions";
import {createJobSkillSaga, deleteJobSkillSaga, fetchJobSkillsSaga, updateJobSkillSaga} from "./sagas/jobSkillSaga";
import {
    FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST,
    FETCH_SKILL_EVALS_BY_USER_REQUEST,
    CREATE_SKILL_EVAL_REQUEST,
    UPDATE_SKILL_EVAL_REQUEST,
    DELETE_SKILL_EVAL_REQUEST,
    SUBMIT_AUTO_EVAL_REQUEST,
    SKILL_MANAGER_DECISION_REQUEST,
    SKILL_RF_DECISION_REQUEST,
    FETCH_SKILL_MANAGER_INBOX_REQUEST,
    FETCH_SKILL_RF_INBOX_REQUEST
} from "./actions/skillEvaluationActions";
import {
    fetchSkillEvalsByCampagneSaga,
    fetchSkillEvalsByUserSaga,
    createSkillEvalSaga,
    updateSkillEvalSaga,
    deleteSkillEvalSaga,
    skillSubmitAutoEvalSaga,
    skillManagerDecisionSaga,
    skillRfDecisionSaga,
    fetchSkillManagerInboxSaga,
    fetchSkillRfInboxSaga
} from "./sagas/skillEvaluationSaga";
import {
    CREATE_MODE_EVALUATION_REQUEST, DELETE_MODE_EVALUATION_REQUEST,
    FETCH_MODES_EVALUATION_REQUEST,
    UPDATE_MODE_EVALUATION_REQUEST
} from "./actions/modeEvaluationActions";
import {
    createModeEvaluationSaga,
    deleteModeEvaluationSaga,
    fetchModesEvaluationSaga,
    updateModeEvaluationSaga
} from "./sagas/modeEvaluationSaga";
import {
    CREATE_CAREER_PATH_REQUEST, DELETE_CAREER_PATH_REQUEST,
    GET_ACTIVE_CAREER_PATHS_REQUEST,
    GET_ALL_CAREER_PATHS_REQUEST,
    GET_CAREER_PATH_REQUEST, UPDATE_CAREER_PATH_REQUEST
} from "./actions/careerPathActions";
import {
    createCareerPathSaga, deleteCareerPathSaga,
    getActiveCareerPathsSaga,
    getAllCareerPathsSaga,
    getCareerPathSaga,
    updateCareerPathSaga
} from "./sagas/careerPathSaga";
import {
    addStepSaga,
    deleteStepSaga,
    getStepSaga,
    getStepsByCareerPathSaga,
    updateStepSaga
} from "./sagas/careerPathStepSaga";
import {
    ADD_STEP_REQUEST, DELETE_STEP_REQUEST,
    GET_STEP_REQUEST,
    GET_STEPS_BY_CAREER_PATH_REQUEST,
    UPDATE_STEP_REQUEST
} from "./actions/careerPathStepActions";
import {
    ASSIGN_CAREER_PATH_REQUEST,
    DELETE_EMPLOYEE_CAREER_PATH_REQUEST,
    GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST,
    GET_EMPLOYEE_CAREER_PATH_REQUEST,
    GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST, UPDATE_EMPLOYEE_CAREER_PATH_REQUEST,
    UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST
} from "./actions/employeeCareerPathActions";
import {
    assignCareerPathSaga, deleteEmployeeCareerPathSaga,
    getAllEmployeeCareerPathsSaga,
    getEmployeeCareerPathSaga,
    getEmployeeCareerPathsByEmployeeSaga, updateEmployeeCareerPathSaga, updateEmployeeCareerPathStatusSaga
} from "./sagas/employeeCareerPathSaga";
import {
    GET_REPERTOIRE_REQUEST,
    GET_ALL_REPERTOIRES_REQUEST,
    GET_REPERTOIRE_TREE_REQUEST,
    GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST,
    GET_REPERTOIRES_BY_STATUS_REQUEST,
    CREATE_REPERTOIRE_REQUEST,
    UPDATE_REPERTOIRE_REQUEST,
    CHANGE_REPERTOIRE_STATUS_REQUEST,
    DELETE_REPERTOIRE_REQUEST
} from "./actions/repertoireActions";

import {
    getRepertoireSaga,
    getAllRepertoiresSaga,
    getRepertoireTreeSaga,
    getAuthorizedRepertoireTreeSaga,
    getRepertoiresByStatusSaga,
    createRepertoireSaga,
    updateRepertoireSaga,
    changeRepertoireStatusSaga,
    deleteRepertoireSaga
} from "./sagas/repertoireSaga";

import {
    CHANGE_EVALUATION_STATUS_REQUEST,
    CREATE_EVALUATION_REQUEST, DELETE_EVALUATION_REQUEST,
    GET_ALL_EVALUATIONS_REQUEST,
    GET_EVALUATION_REQUEST,
    GET_EVALUATIONS_BY_TYPE_REQUEST, UPDATE_EVALUATION_REQUEST
} from "./actions/evaluationActions";
import {
    changeEvaluationStatusSaga,
    createEvaluationSaga, deleteEvaluationSaga,
    getAllEvaluationsSaga,
    getEvaluationSaga,
    getEvaluationsByTypeSaga, updateEvaluationSaga
} from "./sagas/evaluationSaga";

import {
    createModuleSaga, deleteModuleSaga,
    getAllModulesSaga,
    getChildModulesSaga,
    getModuleSaga,
    getModulesByStatusSaga, getRootModulesSaga, updateModuleSaga
} from "./sagas/moduleSaga";
import {
    CREATE_MODULE_REQUEST, DELETE_MODULE_REQUEST,
    GET_ALL_MODULES_REQUEST,
    GET_CHILD_MODULES_REQUEST,
    GET_MODULE_REQUEST,
    GET_MODULES_BY_STATUS_REQUEST, GET_ROOT_MODULES_REQUEST, UPDATE_MODULE_REQUEST
} from "./actions/moduleActions";

import seuilPassageSaga from "./sagas/seuilPassageSagas";


export default function* rootSaga() {
    yield fork(taskSaga);


    yield takeLatest(FETCH_TIMESHEETS_REQUEST, fetchTimesheetsSaga);
    yield takeLatest(GET_TIMESHEET_REQUEST, getTimesheetSaga);
    yield takeLatest(CREATE_TIMESHEET_REQUEST, createTimesheetSaga);
    yield takeLatest(UPDATE_TIMESHEET_REQUEST, updateTimesheetSaga);
    yield takeLatest(DELETE_TIMESHEET_REQUEST, deleteTimesheetSaga);

    yield takeLatest(FETCH_TIMESHEET_DAYS_REQUEST, fetchTimesheetDaysSaga);
    yield takeEvery(UPSERT_TIMESHEET_DAY_REQUEST, upsertTimesheetDaySaga);
    yield takeLatest(DELETE_TIMESHEET_DAY_REQUEST, deleteTimesheetDaySaga);

    // ========================================
    // AUTHENTICATION
    // ========================================
    yield takeLatest(LOGIN_REQUEST, loginSaga);

    yield takeLatest(GET_MY_NOTE_FRAIS_REQUESTS_REQUEST, getMyNoteDeFraisRequestsSaga);
    yield takeLatest(CREATE_NOTE_FRAIS_REQUEST_REQUEST, createNoteDeFraisRequestSaga);
    yield takeLatest(GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST, getManagerNoteDeFraisInboxSaga);
    yield takeLatest(MANAGER_NOTE_FRAIS_DECISION_REQUEST, managerNoteDeFraisDecisionSaga);
    yield takeLatest(GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST, getAdminNoteDeFraisInboxSaga);
    yield takeLatest(ADMIN_NOTE_FRAIS_DECISION_REQUEST, adminNoteDeFraisDecisionSaga);
    yield takeLatest(MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST, marquerNoteDeFraisRembourseeSaga);
    yield takeLatest(GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST, getNoteDeFraisEnAttenteRemboursementSaga);
    yield takeLatest(GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST, getNoteDeFraisByOrdreMissionSaga);
    yield takeLatest(GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST, getManagerNoteDeFraisHistorySaga);
    yield takeLatest(GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST, getAdminNoteDeFraisHistorySaga);

    yield takeLatest(CHECK_BALANCE_REQUEST, checkBalanceSaga);
    yield takeLatest(GET_USER_SOLDES_REQUEST, getUserSoldesSaga);
    yield takeLatest(GET_ALL_COMPANY_SOLDES_REQUEST, getAllCompanySoldesSaga);
    yield takeLatest(CANCEL_LEAVE_REQUEST_REQUEST, cancelLeaveRequestSaga);
    yield takeLatest(EXPORT_SOLDES_EXCEL_REQUEST, exportSoldesExcelSaga);
    yield takeLatest(IMPORT_SOLDES_EXCEL_REQUEST, importSoldesExcelSaga);
    yield takeLatest(UPDATE_SOLDE_REQUEST, updateSoldeSaga);
    yield takeLatest(GET_USER_MOVEMENTS_REQUEST, getUserMovementsSaga);
    yield takeLatest(GET_ALL_MOVEMENTS_REQUEST, getAllMovementsSaga);

    yield takeLatest(GET_MY_AVANCE_REQUESTS_REQUEST, getMyAvanceRequestsSaga);
    yield takeLatest(GET_MY_AVANCES_EN_COURS_REQUEST, getMyAvancesEnCoursSaga);
    yield takeLatest(CREATE_AVANCE_REQUEST_REQUEST, createAvanceRequestSaga);
    yield takeLatest(GET_MANAGER_AVANCE_INBOX_REQUEST, getManagerAvanceInboxSaga);
    yield takeLatest(MANAGER_AVANCE_DECISION_REQUEST, managerAvanceDecisionSaga);
    yield takeLatest(GET_ADMIN_AVANCE_INBOX_REQUEST, getAdminAvanceInboxSaga);
    yield takeLatest(ADMIN_AVANCE_DECISION_REQUEST, adminAvanceDecisionSaga);
    yield takeLatest(ENREGISTRER_REMBOURSEMENT_REQUEST, enregistrerRemboursementSaga);
    yield takeLatest(REMBOURSEMENT_ANTICIPE_REQUEST, remboursementAnticipeSaga);
    yield takeLatest(GET_ADMIN_AVANCE_HISTORY_REQUEST, getAdminAvanceHistorySaga);
    yield takeLatest(EXPORT_AVANCE_REQUESTS_EXCEL_REQUEST, exportAvanceRequestsExcelSaga);

    yield all([
        takeLatest(GET_MY_MISSION_REQUESTS_REQUEST, getMyMissionRequestsSaga),
        takeLatest(GET_MISSION_REQUEST_REQUEST, getMissionRequestSaga),
        takeLatest(CREATE_MISSION_REQUEST_REQUEST, createMissionRequestSaga),
        takeLatest(CANCEL_MISSION_REQUEST_REQUEST, cancelMissionRequestSaga),
        takeLatest(GET_MANAGER_MISSION_INBOX_REQUEST, getManagerMissionInboxSaga),
        takeLatest(MANAGER_MISSION_DECISION_REQUEST, managerMissionDecisionSaga),
        takeLatest(GET_MANAGER_MISSION_HISTORY_REQUEST, getManagerMissionHistorySaga),
        takeLatest(GET_ADMIN_MISSION_INBOX_REQUEST, getAdminMissionInboxSaga),
        takeLatest(ADMIN_MISSION_DECISION_REQUEST, adminMissionDecisionSaga),
        takeLatest(GET_ADMIN_MISSION_HISTORY_REQUEST, getAdminMissionHistorySaga),
        takeLatest(GET_ALL_MISSION_REQUESTS_REQUEST, getAllMissionRequestsSaga),
        takeLatest(FETCH_NIVEAU_SKILLS_REQUEST, fetchNiveauSkillsSaga),
        takeLatest(CREATE_NIVEAU_SKILL_REQUEST, createNiveauSkillSaga),
        takeLatest(UPDATE_NIVEAU_SKILL_REQUEST, updateNiveauSkillSaga),
        takeLatest(DELETE_NIVEAU_SKILL_REQUEST, deleteNiveauSkillSaga),
        takeLatest(FETCH_JOB_SKILLS_REQUEST, fetchJobSkillsSaga),
        takeLatest(CREATE_JOB_SKILL_REQUEST, createJobSkillSaga),
        takeLatest(UPDATE_JOB_SKILL_REQUEST, updateJobSkillSaga),
        takeLatest(DELETE_JOB_SKILL_REQUEST, deleteJobSkillSaga),
        takeLatest(FETCH_MODES_EVALUATION_REQUEST, fetchModesEvaluationSaga),
        takeLatest(CREATE_MODE_EVALUATION_REQUEST, createModeEvaluationSaga),
        takeLatest(UPDATE_MODE_EVALUATION_REQUEST, updateModeEvaluationSaga),
        takeLatest(DELETE_MODE_EVALUATION_REQUEST, deleteModeEvaluationSaga),
    ]);


    // ========================================
    // SKILLS EVALUATIONS
    // ========================================
    yield takeLatest(FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST, fetchSkillEvalsByCampagneSaga);
    yield takeLatest(FETCH_SKILL_EVALS_BY_USER_REQUEST, fetchSkillEvalsByUserSaga);
    yield takeLatest(CREATE_SKILL_EVAL_REQUEST, createSkillEvalSaga);
    yield takeLatest(UPDATE_SKILL_EVAL_REQUEST, updateSkillEvalSaga);
    yield takeLatest(DELETE_SKILL_EVAL_REQUEST, deleteSkillEvalSaga);
    yield takeLatest(SUBMIT_AUTO_EVAL_REQUEST, skillSubmitAutoEvalSaga);
    yield takeLatest(SKILL_MANAGER_DECISION_REQUEST, skillManagerDecisionSaga);
    yield takeLatest(SKILL_RF_DECISION_REQUEST, skillRfDecisionSaga);
    yield takeLatest(FETCH_SKILL_MANAGER_INBOX_REQUEST, fetchSkillManagerInboxSaga);
    yield takeLatest(FETCH_SKILL_RF_INBOX_REQUEST, fetchSkillRfInboxSaga);

    // ========================================
    // USERS
    // ========================================
    yield all([
        takeLatest(GET_CALENDAR_SETTINGS_REQUEST, getCalendarSettingsSaga),
        takeLatest(GET_WORKDAYS_CONFIG_REQUEST, getWorkdaysConfigSaga),
        takeLatest(UPDATE_CALENDAR_SETTINGS_REQUEST, updateCalendarSettingsSaga),
        takeLatest(UPDATE_WORKDAYS_CONFIG_REQUEST, updateWorkdaysConfigSaga),

        // Notifications
        takeLatest(GET_NOTIFICATION_SETTINGS_REQUEST, getNotificationSettingsSaga),
        takeLatest(CREATE_NOTIFICATION_SETTING_REQUEST, createNotificationSettingSaga),
        takeLatest(UPDATE_NOTIFICATION_SETTING_REQUEST, updateNotificationSettingSaga),
        takeLatest(DELETE_NOTIFICATION_SETTING_REQUEST, deleteNotificationSettingSaga),

        fork(watchNotificationSagas),
    ]);

    // ========================================
    // USERS
    // ========================================
    yield takeLatest(GET_USER_REQUEST, getUserSaga);
    yield takeLatest(GET_ALL_USERS_REQUEST, getAllUsersSaga);
    yield takeLatest(UPDATE_MY_PROFILE_REQUEST, updateMyProfileSaga);
    yield takeLatest(UPLOAD_USER_PHOTO_REQUEST, uploadUserPhotoSaga);
    yield takeLatest(EXPORT_USERS_REQUEST, exportUsersSaga);

    yield takeLatest(FETCH_SKILLS_REQUEST,             fetchSkillsSaga);
    yield takeLatest(FETCH_SKILLS_BY_TYPE_REQUEST,     fetchSkillsByTypeSaga);
    yield takeLatest(CREATE_SKILL_REQUEST,             createSkillSaga);
    yield takeLatest(UPDATE_SKILL_REQUEST,             updateSkillSaga);
    yield takeLatest(DELETE_SKILL_REQUEST,             deleteSkillSaga);
    yield takeLatest(DOWNLOAD_SKILLS_TEMPLATE_REQUEST, downloadSkillsTemplateSaga);
    yield takeLatest(IMPORT_SKILLS_EXCEL_REQUEST,      importSkillsExcelSaga);
    yield takeLatest(EXPORT_SKILLS_REQUEST,            exportSkillsSaga);

    yield takeLatest(GET_USERS_BY_STATUS_REQUEST, getUsersByStatusSaga);
    yield takeLatest(GET_USERS_BY_JOB_REQUEST, getUsersByJobSaga);
    yield takeLatest(GET_USERS_BY_ENTITY_REQUEST, getUsersByEntitySaga);
    yield takeLatest(CREATE_USER_REQUEST, createUserSaga);
    yield takeLatest(UPDATE_USER_REQUEST, updateUserSaga);
    yield takeLatest(DELETE_USER_REQUEST, deleteUserSaga);
    yield takeLatest(ASSIGN_ROLES_REQUEST, assignRolesSaga);
    yield takeLatest(REMOVE_ROLES_REQUEST, removeRolesSaga);
    yield takeLatest(MASS_IMPORT_USERS_REQUEST, massImportUsersSaga);
    yield takeLatest(DOWNLOAD_USERS_TEMPLATE_REQUEST, downloadUsersTemplateSaga);
    yield takeLatest(REVIEW_USERS_MASS_IMPORT_REQUEST, reviewUsersMassImportSaga);
    yield takeLatest(IMPORT_USERS_MASS_REQUEST, importUsersMassSaga);
    yield takeLatest(GET_TROMBINOSCOPE_REQUEST, getTrombinoscopeSaga);
    yield takeLatest(GET_USER_JOB_HISTORY_REQUEST, getUserJobHistorySaga);
    yield takeLatest(CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST, createMissionRequestForCollabSaga);

    yield takeLatest(GET_DIRECT_REPORTS_REQUEST, getDirectReportsSaga);

    yield takeLatest(FETCH_CAMPAGNES_REQUEST, fetchCampagnesSaga);
    yield takeLatest(FETCH_VISIBLE_CAMPAGNES_REQUEST, fetchVisibleCampagnesSaga);
    yield takeLatest(FETCH_BUDGET_BY_CAMPAGNE_REQUEST, fetchBudgetByCampagneSaga);
    yield takeLatest(CREATE_CAMPAGNE_REQUEST, createCampagneSaga);
    yield takeLatest(UPDATE_CAMPAGNE_REQUEST, updateCampagneSaga);
    yield takeLatest(DELETE_CAMPAGNE_REQUEST, deleteCampagneSaga);


    yield     takeLatest(FETCH_ATTESTATIONS_REQUEST, fetchAttestationsSaga);
    yield    takeLatest(CREATE_ATTESTATION_REQUEST, createAttestationSaga);
    yield  takeLatest(UPDATE_ATTESTATION_REQUEST, updateAttestationSaga);
    yield takeLatest(DELETE_ATTESTATION_REQUEST, deleteAttestationSaga);

    yield   takeLatest(GET_MY_ATTESTATION_REQUESTS_REQUEST, getMyAttestationRequestsSaga);
    yield         takeLatest(CREATE_ATTESTATION_REQUEST_REQUEST, createAttestationRequestSaga);

    yield    takeLatest(GET_MANAGER_ATTESTATION_INBOX_REQUEST, getManagerAttestationInboxSaga);
    yield     takeLatest(MANAGER_ATTESTATION_DECISION_REQUEST, managerAttestationDecisionSaga);

    yield     takeLatest(GET_ADMIN_ATTESTATION_INBOX_REQUEST, getAdminAttestationInboxSaga);
    yield     takeLatest(ADMIN_ATTESTATION_DECISION_REQUEST, adminAttestationDecisionSaga);

    yield    takeLatest(DOWNLOAD_ATTESTATION_PDF_REQUEST, downloadAttestationPdfSaga);
    yield    takeLatest(DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST, downloadAttestationRequestPdfSaga);

    // ========================================
    // postes
    // ========================================

    yield takeLatest(GET_ALL_JOBS_REQUEST, getAllJobsSaga);
    yield takeLatest(CREATE_JOB_REQUEST, createJobSaga);
    yield takeLatest(UPDATE_JOB_REQUEST, updateJobSaga);
    yield takeLatest(DELETE_JOB_REQUEST, deleteJobSaga);
    yield takeLatest(IMPORT_JOBS_EXCEL_REQUEST, importJobsExcelSaga);
    yield takeLatest(EXPORT_JOBS_REQUEST, exportJobsExcelSaga);
    yield takeLatest(DOWNLOAD_JOBS_TEMPLATE_REQUEST, downloadJobsTemplateSaga);
// ========================================
    // entites
    // ========================================

    yield takeLatest(GET_ALL_ENTITES_REQUEST, getAllEntitesSaga);
    yield takeLatest(CREATE_ENTITE_REQUEST, createEntiteSaga);
    yield takeLatest(UPDATE_ENTITE_REQUEST, updateEntiteSaga);
    yield takeLatest(DELETE_ENTITE_REQUEST, deleteEntiteSaga);
    yield takeLatest(GET_ORGANIGRAMME_REQUEST, getOrgSaga);
    yield takeLatest(IMPORT_ENTITIES_EXCEL_REQUEST, importEntitiesExcelSaga);
    yield takeLatest(EXPORT_ENTITIES_REQUEST, exportEntitiesExcelSaga);
    yield takeLatest(DOWNLOAD_ENTITIES_TEMPLATE_REQUEST, downloadEntitiesTemplateSaga);


    // ========================================
    // sidebarmenus
    // ========================================

    yield takeLatest(GET_SIDEBAR_MENU_REQUEST, getSidebarMenuSaga);
    yield takeLatest(GET_ALL_SIDEBAR_MENUS_REQUEST, getAllSidebarMenusSaga);
    yield takeLatest(GET_ORDERED_SIDEBAR_MENUS_REQUEST, getOrderedSidebarMenusSaga);
    yield takeLatest(GET_SIDEBAR_MENUS_BY_ROLE_REQUEST, getSidebarMenusByRoleSaga);
    yield takeLatest(GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST, getSidebarMenusByRoleAdminSaga);

    yield takeLatest(GET_SIDEBAR_MENUS_BY_STATUS_REQUEST, getSidebarMenusByStatusSaga);
    yield takeLatest(GET_ROOT_SIDEBAR_MENUS_REQUEST, getRootSidebarMenusSaga);
    yield takeLatest(GET_CHILD_SIDEBAR_MENUS_REQUEST, getChildSidebarMenusSaga);

    yield takeLatest(CREATE_SIDEBAR_MENU_REQUEST, createSidebarMenuSaga);
    yield takeLatest(UPDATE_SIDEBAR_MENU_REQUEST, updateSidebarMenuSaga);
    yield takeLatest(DELETE_SIDEBAR_MENU_REQUEST, deleteSidebarMenuSaga);

// AVANTAGES SOCIAUX


    yield takeLatest(FETCH_PARAM_AVANTAGES_REQUEST, fetchParamAvantagesSaga);

    yield takeLatest(CREATE_AV_CAT_REQUEST, createAvCatSaga);
    yield takeLatest(UPDATE_AV_CAT_REQUEST, updateAvCatSaga);
    yield takeLatest(DELETE_AV_CAT_REQUEST, deleteAvCatSaga);

    yield takeLatest(CREATE_AV_REGLE_REQUEST, createAvRegleSaga);
    yield takeLatest(UPDATE_AV_REGLE_REQUEST, updateAvRegleSaga);
    yield takeLatest(DELETE_AV_REGLE_REQUEST, deleteAvRegleSaga);

    yield takeLatest(CREATE_AVANTAGE_REQUEST, createAvantageSaga);
    yield takeLatest(UPDATE_AVANTAGE_REQUEST, updateAvantageSaga);
    yield takeLatest(DELETE_AVANTAGE_REQUEST, deleteAvantageSaga);
    // ========================================
    // companies
    // ========================================

    yield takeLatest(GET_COMPANY_REQUEST, getCompanySaga);
    yield takeLatest(GET_COMPANY_BY_CODE_REQUEST, getCompanyByCodeSaga);
    yield takeLatest(GET_ALL_COMPANIES_REQUEST, getAllCompaniesSaga);
    yield takeLatest(CREATE_COMPANY_REQUEST, createCompanySaga);
    yield takeLatest(UPDATE_COMPANY_REQUEST, updateCompanySaga);
    yield takeLatest(DELETE_COMPANY_REQUEST, deleteCompanySaga);
    yield takeLatest(GET_HOLIDAYS_REQUEST, getHolidaysSaga);


    // ========================================
    // roles
    // ========================================
    yield takeLatest(GET_ROLE_REQUEST, getRoleSaga);
    yield takeLatest(GET_ALL_ROLES_REQUEST, getAllRolesSaga);
    yield takeLatest(GET_ACTIVE_ROLES_REQUEST, getActiveRolesSaga);
    yield takeLatest(GET_ROLES_BY_MODULE_REQUEST, getRolesByModuleSaga);
    yield takeLatest(GET_GLOBAL_ROLES_REQUEST, getGlobalRolesSaga);
    yield takeLatest(CREATE_ROLE_REQUEST, createRoleSaga);
    yield takeLatest(UPDATE_ROLE_REQUEST, updateRoleSaga);
    yield takeLatest(DELETE_ROLE_REQUEST, deleteRoleSaga);



    yield takeLatest(GET_MODULE_REQUEST, getModuleSaga);
    yield takeLatest(GET_ALL_MODULES_REQUEST, getAllModulesSaga);
    yield takeLatest(GET_MODULES_BY_STATUS_REQUEST, getModulesByStatusSaga);
    yield takeLatest(GET_ROOT_MODULES_REQUEST, getRootModulesSaga);
    yield takeLatest(GET_CHILD_MODULES_REQUEST, getChildModulesSaga);
    yield takeLatest(CREATE_MODULE_REQUEST, createModuleSaga);
    yield takeLatest(UPDATE_MODULE_REQUEST, updateModuleSaga);
    yield takeLatest(DELETE_MODULE_REQUEST, deleteModuleSaga);
    // ========================================
    // work flow grh
    // ========================================

    yield takeLatest(GET_WORKFLOW_LEVELS_REQUEST, getWorkflowLevelsSaga);
    yield takeLatest(SAVE_WORKFLOW_LEVELS_REQUEST, saveWorkflowLevelsSaga);

    // ========================================
    // PARAM_CONGES
    // ========================================


    yield takeLatest(FETCH_PARAM_CONGES_REQUEST, fetchParamCongesSaga);

    yield takeLatest(CREATE_ABSENCE_TYPE_REQUEST, createAbsenceTypeSaga);
    yield takeLatest(UPDATE_ABSENCE_TYPE_REQUEST, updateAbsenceTypeSaga);
    yield takeLatest(DELETE_ABSENCE_TYPE_REQUEST, deleteAbsenceTypeSaga);

    yield takeLatest(CREATE_ACQ_RULE_REQUEST, createAcqRuleSaga);
    yield takeLatest(UPDATE_ACQ_RULE_REQUEST, updateAcqRuleSaga);

    yield takeLatest(DELETE_ACQ_RULE_REQUEST, deleteAcqRuleSaga);

    yield takeLatest(FETCH_MES_AVANTAGES_REQUEST, fetchMesAvantagesSaga);

    yield takeLatest(CREATE_JUSTIF_RULE_REQUEST, createJustifRuleSaga);
    yield takeLatest(UPDATE_JUSTIF_RULE_REQUEST, updateJustifRuleSaga);

    yield takeLatest(DELETE_JUSTIF_RULE_REQUEST, deleteJustifRuleSaga);
    yield takeLatest(INIT_STANDARD_CONFIG_REQUEST, initStandardConfigSaga);

    yield takeLatest(CREATE_LEAVE_REQUEST_REQUEST, createLeaveRequestSaga);

    yield takeLatest(GET_MY_LEAVE_REQUESTS_REQUEST, getMyLeaveRequestsSaga);
    yield takeLatest(GET_ALL_LEAVE_REQUESTS_REQUEST, getAllLeaveRequestsSaga);

    yield takeLatest(GET_MANAGER_INBOX_REQUEST, getManagerInboxSaga);
    yield takeLatest(GET_MANAGER_HISTORY_REQUEST, getManagerHistorySaga);
    yield takeLatest(GET_MANAGER_TEAM_LEAVES_REQUEST, getManagerTeamLeavesSaga);
    yield takeLatest(MANAGER_DECISION_REQUEST, managerDecisionSaga);
    yield takeLatest(MANAGER_DELEGATE_TO_ADMIN_REQUEST, managerDelegateToAdminSaga);
    yield takeLatest(POSTPONE_LEAVE_REQUEST_REQUEST, postponeLeaveRequestSaga);
    yield takeLatest(UPLOAD_LEAVE_JUSTIFICATIFS_REQUEST, uploadLeaveJustificatifsSaga);

    yield    takeLatest(GET_ADMIN_INBOX_REQUEST, getAdminInboxSaga);
    yield   takeLatest(ADMIN_DECISION_REQUEST, adminDecisionSaga);
    yield takeLatest(EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST, exportLeaveRequestsExcelSaga);


    yield takeLatest(FETCH_NOTE_DE_FRAIS_REQUEST, fetchNoteDeFraisSaga);
    yield takeLatest(FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST, fetchNoteDeFraisByIdSaga);
    yield takeLatest(CREATE_NOTE_DE_FRAIS_REQUEST, createNoteDeFraisSaga);
    yield takeLatest(UPDATE_NOTE_DE_FRAIS_REQUEST, updateNoteDeFraisSaga);
    yield takeLatest(DELETE_NOTE_DE_FRAIS_REQUEST, deleteNoteDeFraisSaga);
    yield takeLatest(FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST, fetchNoteDeFraisActifsSaga);



    // ========================================
    // ORDRE DE MISSIONS
    // ========================================
    yield takeLatest(FETCH_ORDRE_MISSION_REQUEST, fetchOrdreMissionSaga);
    yield takeLatest(FETCH_ORDRE_MISSION_BY_ID_REQUEST, fetchOrdreMissionByIdSaga);
    yield takeLatest(CREATE_ORDRE_MISSION_REQUEST, createOrdreMissionSaga);
    yield takeLatest(UPDATE_ORDRE_MISSION_REQUEST, updateOrdreMissionSaga);
    yield takeLatest(DELETE_ORDRE_MISSION_REQUEST, deleteOrdreMissionSaga);
    yield takeLatest(FETCH_ORDRE_MISSION_ACTIFS_REQUEST, fetchOrdreMissionActifsSaga);
    yield takeLatest(FETCH_ORDRE_MISSION_EN_COURS_REQUEST, fetchOrdreMissionEnCoursSaga);
    yield takeLatest(FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST, fetchOrdreMissionByPeriodSaga);


    yield takeLatest(FETCH_DOMAINES_REQUEST, fetchDomainesSaga);
    yield   takeLatest(FETCH_THEMES_REQUEST, fetchThemesSaga);
    yield   takeLatest(FETCH_THEMES_BY_DOMAINE_REQUEST, fetchThemesByDomaineSaga);

    yield   takeLatest(CREATE_DOMAINE_REQUEST, createDomaineSaga);
    yield   takeLatest(UPDATE_DOMAINE_REQUEST, updateDomaineSaga);
    yield   takeLatest(DELETE_DOMAINE_REQUEST, deleteDomaineSaga);

    yield   takeLatest(CREATE_THEME_REQUEST, createThemeSaga);
    yield   takeLatest(UPDATE_THEME_REQUEST, updateThemeSaga);
    yield   takeLatest(DELETE_THEME_REQUEST, deleteThemeSaga);



    yield takeLatest(DOWNLOAD_DOMAINES_TEMPLATE_REQUEST, downloadDomainesTemplateSaga);
    yield takeLatest(DOWNLOAD_THEMES_TEMPLATE_REQUEST, downloadThemesTemplateSaga);

    yield takeLatest(IMPORT_DOMAINES_EXCEL_REQUEST, importDomainesExcelSaga);
    yield takeLatest(IMPORT_THEMES_EXCEL_REQUEST, importThemesExcelSaga);
    yield takeLatest(FETCH_FORMATIONS_REQUEST, fetchFormationsSaga);
    yield takeLatest(CREATE_FORMATION_REQUEST, createFormationSaga);
    yield takeLatest(UPDATE_FORMATION_REQUEST, updateFormationSaga);
    yield takeLatest(DELETE_FORMATION_REQUEST, deleteFormationSaga);

    yield takeLatest(DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST, downloadTemplateSaga);
    yield takeLatest(IMPORT_FORMATIONS_EXCEL_REQUEST, importExcelSaga);
    yield takeLatest(EXPORT_FORMATIONS_REQUEST, exportExcelSaga);

    yield takeLatest(FETCH_OFFBOARDINGS_REQUEST, fetchOffboardingsSaga);
    yield takeLatest(GET_OFFBOARDING_REQUEST, getOffboardingSaga);
    yield takeLatest(CREATE_OFFBOARDING_REQUEST, createOffboardingSaga);
    yield takeLatest(UPDATE_OFFBOARDING_REQUEST, updateOffboardingSaga);
    yield takeLatest(DELETE_OFFBOARDING_REQUEST, deleteOffboardingSaga);

    yield takeLatest(FETCH_ETAPES_REQUEST, fetchEtapesSaga);
    yield takeLatest(CREATE_ETAPE_REQUEST, createEtapeSaga);
    yield takeLatest(UPDATE_ETAPE_REQUEST, updateEtapeSaga);
    yield takeLatest(DELETE_ETAPE_REQUEST, deleteEtapeSaga);

    yield takeLatest(FETCH_AVANCE_REQUEST, fetchAvanceSaga);
    yield takeLatest(FETCH_AVANCE_BY_ID_REQUEST, fetchAvanceByIdSaga);
    yield takeLatest(CREATE_AVANCE_REQUEST, createAvanceSaga);
    yield takeLatest(UPDATE_AVANCE_REQUEST, updateAvanceSaga);
    yield takeLatest(DELETE_AVANCE_REQUEST, deleteAvanceSaga);
    yield takeLatest(FETCH_AVANCE_ACTIFS_REQUEST, fetchAvanceActifsSaga);


    yield takeLatest(FETCH_CATALOGUES_REQUEST, fetchCataloguesSaga);
    yield takeLatest(CREATE_CATALOGUE_REQUEST, createCatalogueSaga);
    yield takeLatest(UPDATE_CATALOGUE_REQUEST, updateCatalogueSaga);
    yield takeLatest(DELETE_CATALOGUE_REQUEST, deleteCatalogueSaga);


    yield takeLatest(GET_MY_DEMANDES_REQUEST, getMyDemandesSaga);
    yield takeLatest(GET_CREATED_BY_ME_DEMANDES_REQUEST, getCreatedByMeDemandesSaga);

    yield takeLatest(CREATE_DEMANDE_COLLAB_REQUEST, createDemandeCollabSaga);
    yield takeLatest(CREATE_DEMANDE_MANAGER_REQUEST, createDemandeManagerSaga);
    yield takeLatest(CREATE_DEMANDE_RF_REQUEST, createDemandeRfSaga);

    yield takeLatest(CREATE_DEMANDE_MANAGER_BULK_REQUEST, createDemandeManagerBulkSaga);
    yield takeLatest(CREATE_DEMANDE_RF_BULK_REQUEST, createDemandeRfBulkSaga);

    yield takeLatest(GET_DEMANDE_MANAGER_INBOX_REQUEST, getDemandeManagerInboxSaga);
    yield takeLatest(GET_DEMANDE_RF_INBOX_REQUEST, getDemandeRfInboxSaga);

    yield takeLatest(DEMANDE_MANAGER_DECISION_REQUEST, demandeManagerDecisionSaga);
    yield takeLatest(DEMANDE_RF_DECISION_REQUEST, demandeRfDecisionSaga);
    yield takeLatest(DOWNLOAD_PLAN_FORMATION_REQUEST, downloadGeneratePlanFormationExcelSaga);
    yield takeLatest(DOWNLOAD_BILAN_FORMATION_REQUEST, downloadGenerateBilanCampagneExcelSaga);

    yield takeLatest(GET_COMPANY_DEMANDES_REQUEST, getCompanyDemandesSaga);

    yield takeLatest(FETCH_FORMATIONS_BY_CATALOGUE_REQUEST, fetchFormationsByCatalogueSaga);


    yield takeLatest(FETCH_DEMANDES_RECRUTEMENT_REQUEST, fetchDemandesRecrutementSaga);
    yield takeLatest(CREATE_DEMANDE_RECRUTEMENT_REQUEST, createDemandeRecrutementSaga);
    yield takeLatest(UPDATE_DEMANDE_RECRUTEMENT_REQUEST, updateDemandeRecrutementSaga);
    yield takeLatest(DELETE_DEMANDE_RECRUTEMENT_REQUEST, deleteDemandeRecrutementSaga);
    yield takeLatest(APPROVE_DEMANDE_RECRUTEMENT_REQUEST, approveDemandeRecrutementSaga);
    yield takeLatest(REJECT_DEMANDE_RECRUTEMENT_REQUEST, rejectDemandeRecrutementSaga);
    yield takeLatest(CANCEL_DEMANDE_RECRUTEMENT_REQUEST, cancelDemandeRecrutementSaga);
    yield takeLatest(SEND_OFFER_TO_CHASSEURS_REQUEST, sendOfferToChasseursSaga);
    yield takeLatest(SEND_OFFER_TO_PARTENAIRES_REQUEST, sendOfferToPartenairesSaga);
    ////SALLES
    yield takeLatest(FETCH_SALLES_REQUEST, fetchSallesSaga);
    yield takeLatest(CREATE_SALLE_REQUEST, createSalleSaga);
    yield takeLatest(UPDATE_SALLE_REQUEST, updateSalleSaga);
    yield takeLatest(DELETE_SALLE_REQUEST, deleteSalleSaga);

    yield   takeLatest(FETCH_FOURNISSEURS_REQUEST, fetchFournisseursSaga);
    yield     takeLatest(CREATE_FOURNISSEUR_REQUEST, createFournisseurSaga);
    yield    takeLatest(UPDATE_FOURNISSEUR_REQUEST, updateFournisseurSaga);
    yield    takeLatest(DELETE_FOURNISSEUR_REQUEST, deleteFournisseurSaga);

    // Consultants
    yield   takeLatest(FETCH_CONSULTANTS_REQUEST, fetchConsultantsSaga);
    yield   takeLatest(CREATE_CONSULTANT_REQUEST, createConsultantSaga);
    yield   takeLatest(UPDATE_CONSULTANT_REQUEST, updateConsultantSaga);
    yield  takeLatest(DELETE_CONSULTANT_REQUEST, deleteConsultantSaga);

// modules
    yield  takeLatest(FETCH_MODULES_CLE_REQUEST, fetchModulesCleSaga);
    yield     takeLatest(CREATE_MODULE_CLE_REQUEST, createModuleCleSaga);
    yield    takeLatest(UPDATE_MODULE_CLE_REQUEST, updateModuleCleSaga);
    yield   takeLatest(DELETE_MODULE_CLE_REQUEST, deleteModuleCleSaga);

    // Events

    yield takeLatest(FETCH_EVENTS_REQUEST,      fetchEventsSaga);
    yield takeLatest(CREATE_EVENT_REQUEST,      createEventSaga);
    yield takeLatest(UPDATE_EVENT_REQUEST,      updateEventSaga);
    yield takeLatest(DELETE_EVENT_REQUEST,      deleteEventSaga);
// ── Nouvelles ──────────────────────────────────────────────
    yield takeLatest(CANCEL_EVENT_REQUEST,      cancelEventSaga);
    yield takeLatest(REPLANIFY_EVENT_REQUEST,   replanifyEventSaga);
    yield takeLatest(DUPLICATE_EVENT_REQUEST,   duplicateEventSaga);
    yield takeLatest(EXPORT_BUDGET_REQUEST,     exportBudgetSaga);
    yield takeLatest(EXPORT_FORMATIONS_REQUEST, exportFormationsSaga);
    yield takeLatest(IMPORT_EVENTS_EXCEL_REQUEST,      importEventsExcelSaga);
    yield takeLatest(EXPORT_EVENTS_EXCEL_REQUEST,      exportEventsExcelSaga);
    yield takeLatest(DOWNLOAD_EVENTS_TEMPLATE_REQUEST, downloadEventsTemplateSaga);

    yield takeLatest(FETCH_CHASSEURS_REQUEST, fetchChasseursSaga);
    yield takeLatest(CREATE_CHASSEUR_REQUEST, createChasseurSaga);
    yield takeLatest(UPDATE_CHASSEUR_REQUEST, updateChasseurSaga);
    yield takeLatest(DELETE_CHASSEUR_REQUEST, deleteChasseurSaga);
    yield takeLatest(FETCH_DOMAINES_REQUEST, fetchDomainesSaga);

    yield takeLatest(FETCH_PARTENAIRES_ACAD_REQUEST, fetchPartenairesAcadSaga);
    yield takeLatest(CREATE_PARTENAIRE_ACAD_REQUEST, createPartenaireAcadSaga);
    yield takeLatest(UPDATE_PARTENAIRE_ACAD_REQUEST, updatePartenaireAcadSaga);
    yield takeLatest(DELETE_PARTENAIRE_ACAD_REQUEST, deletePartenaireAcadSaga);

    yield takeLatest(FETCH_TIMESHEET_MANAGER_INBOX_REQUEST, fetchManagerInboxSaga);
    yield takeLatest(FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,   fetchAdminInboxSaga);
    yield takeLatest(TIMESHEET_MANAGER_DECISION_REQUEST,    timesheetManagerDecisionSaga);
    yield takeLatest(TIMESHEET_ADMIN_DECISION_REQUEST,      timesheetAdminDecisionSaga);


    yield takeLatest(FETCH_ETABLISSEMENTS_REQUEST, fetchEtablissementsSaga);
    yield takeLatest(CREATE_ETABLISSEMENT_REQUEST, createEtablissementSaga);
    yield takeLatest(UPDATE_ETABLISSEMENT_REQUEST, updateEtablissementSaga);
    yield takeLatest(DELETE_ETABLISSEMENT_REQUEST, deleteEtablissementSaga);


    yield takeLatest(FETCH_CANDIDATS_REQUEST, fetchCandidatsSaga);
    yield takeLatest(CREATE_CANDIDAT_REQUEST, createCandidatSaga);
    yield takeLatest(UPDATE_CANDIDAT_REQUEST, updateCandidatSaga);
    yield takeLatest(DELETE_CANDIDAT_REQUEST, deleteCandidatSaga);

    yield takeLatest(GET_ALL_EMAIL_TEMPLATES_REQUEST, getAllEmailTemplatesSaga);
    yield takeLatest(GET_EMAIL_TEMPLATE_REQUEST, getEmailTemplateSaga);
    yield takeLatest(CREATE_EMAIL_TEMPLATE_REQUEST, createEmailTemplateSaga);
    yield takeLatest(UPDATE_EMAIL_TEMPLATE_REQUEST, updateEmailTemplateSaga);
    yield takeLatest(DELETE_EMAIL_TEMPLATE_REQUEST, deleteEmailTemplateSaga);
    yield takeLatest(GET_EMAIL_PLACEHOLDERS_REQUEST, getEmailPlaceholdersSaga);
    yield takeLatest(PREVIEW_EMAIL_TEMPLATE_REQUEST, previewEmailTemplateSaga);
    yield takeLatest(SEND_ACCOUNT_ACTIVATION_REQUEST, sendAccountActivationSaga);
    yield takeLatest(GET_EMAIL_LOGS_REQUEST, getEmailLogsSaga);
    yield takeLatest(REQUEST_PASSWORD_RESET_REQUEST, requestPasswordResetSaga);
    yield takeLatest(CONFIRM_PASSWORD_RESET_REQUEST, confirmPasswordResetSaga);

    yield takeLatest(GET_APPLICATION_LOGS_REQUEST, getApplicationLogsSaga);
    yield takeLatest(GET_APPLICATION_LOG_REQUEST, getApplicationLogSaga);
    yield takeLatest(GET_APPLICATION_LOGS_BY_MODULE_REQUEST, getApplicationLogsByModuleSaga);
    yield takeLatest(GET_APPLICATION_LOGS_BY_USER_REQUEST, getApplicationLogsByUserSaga);

    // ── Career Path ───────────────────────────────────────────
    yield takeLatest(GET_ALL_CAREER_PATHS_REQUEST, getAllCareerPathsSaga);
    yield takeLatest(GET_ACTIVE_CAREER_PATHS_REQUEST, getActiveCareerPathsSaga);
    yield takeLatest(GET_CAREER_PATH_REQUEST, getCareerPathSaga);
    yield takeLatest(CREATE_CAREER_PATH_REQUEST, createCareerPathSaga);
    yield takeLatest(UPDATE_CAREER_PATH_REQUEST, updateCareerPathSaga);
    yield takeLatest(DELETE_CAREER_PATH_REQUEST, deleteCareerPathSaga);

// ── Career Path Step ──────────────────────────────────────
    yield takeLatest(GET_STEPS_BY_CAREER_PATH_REQUEST, getStepsByCareerPathSaga);
    yield takeLatest(GET_STEP_REQUEST, getStepSaga);
    yield takeLatest(ADD_STEP_REQUEST, addStepSaga);
    yield takeLatest(UPDATE_STEP_REQUEST, updateStepSaga);
    yield takeLatest(DELETE_STEP_REQUEST, deleteStepSaga);

// ── Employee Career Path ──────────────────────────────────
    yield takeLatest(GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST, getAllEmployeeCareerPathsSaga);
    yield takeLatest(GET_EMPLOYEE_CAREER_PATH_REQUEST, getEmployeeCareerPathSaga);
    yield takeLatest(GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST, getEmployeeCareerPathsByEmployeeSaga);
    yield takeLatest(ASSIGN_CAREER_PATH_REQUEST, assignCareerPathSaga);
    yield takeLatest(UPDATE_EMPLOYEE_CAREER_PATH_REQUEST, updateEmployeeCareerPathSaga);
    yield takeLatest(UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST, updateEmployeeCareerPathStatusSaga);
    yield takeLatest(DELETE_EMPLOYEE_CAREER_PATH_REQUEST, deleteEmployeeCareerPathSaga);

    yield takeLatest(GET_REPERTOIRE_REQUEST, getRepertoireSaga);
    yield takeLatest(GET_ALL_REPERTOIRES_REQUEST, getAllRepertoiresSaga);
    yield takeLatest(GET_REPERTOIRE_TREE_REQUEST, getRepertoireTreeSaga);
    yield takeLatest(GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST, getAuthorizedRepertoireTreeSaga);
    yield takeLatest(GET_REPERTOIRES_BY_STATUS_REQUEST, getRepertoiresByStatusSaga);
    yield takeLatest(CREATE_REPERTOIRE_REQUEST, createRepertoireSaga);
    yield takeLatest(UPDATE_REPERTOIRE_REQUEST, updateRepertoireSaga);
    yield takeLatest(CHANGE_REPERTOIRE_STATUS_REQUEST, changeRepertoireStatusSaga);
    yield takeLatest(DELETE_REPERTOIRE_REQUEST, deleteRepertoireSaga);

    yield takeLatest(GET_EVALUATION_REQUEST, getEvaluationSaga);
    yield takeLatest(GET_ALL_EVALUATIONS_REQUEST, getAllEvaluationsSaga);
    yield takeLatest(GET_EVALUATIONS_BY_TYPE_REQUEST, getEvaluationsByTypeSaga);
    yield takeLatest(CREATE_EVALUATION_REQUEST, createEvaluationSaga);
    yield takeLatest(UPDATE_EVALUATION_REQUEST, updateEvaluationSaga);
    yield takeLatest(DELETE_EVALUATION_REQUEST, deleteEvaluationSaga);
    yield takeLatest(CHANGE_EVALUATION_STATUS_REQUEST, changeEvaluationStatusSaga);

    yield takeLatest(GET_ADMIN_AVANCE_HISTORY_REQUEST, getAdminAvanceHistorySaga);
    yield takeLatest(GET_MANAGER_AVANCE_HISTORY_REQUEST, getManagerAvanceHistorySaga);

    yield* seuilPassageSaga();
    
    yield fork(watchTaskSettings);
}
